import { Layout, UserManagement as UserManagementComponent } from "components"
export const UserManagement = () => {
 return (
  <Layout>
   <UserManagementComponent />
  </Layout>
 )
}
